import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icons/member.png'


const _hoisted_1 = { class: "navbar-content" }
const _hoisted_2 = { class: "navbar-nav" }
const _hoisted_3 = { class: "nav-item dropdown langs" }
const _hoisted_4 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_5 = { class: "alert-numbers lang" }
const _hoisted_6 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_7 = { class: "list-unstyled" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "symbole-lang" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "wd-30 ht-30 rounded-circle",
    src: _imports_0,
    alt: "profile"
  })
], -1)
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_13 = { class: "d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = { class: "tx-16 text-uppercase" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "tx-16" }
const _hoisted_18 = { class: "list-unstyled" }
const _hoisted_19 = {
  key: 0,
  class: "dropdown-item cursor-pointer border-bottom"
}
const _hoisted_20 = { class: "bg-none text-body py-1 d-block w-100" }
const _hoisted_21 = { class: "link-title" }
const _hoisted_22 = { class: "dropdown-item cursor-pointer border-bottom" }
const _hoisted_23 = { class: "dropdown-item cursor-pointer border-bottom" }
const _hoisted_24 = { class: "bg-none text-body py-1 d-block w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.userUUID)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: _normalizeClass(["navbar z-index-999", _ctx.classes])
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["sidebar-toggler cursor-pointer", _ctx.isTogglerActive ? 'active' : 'not-active']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "bars",
            size: "lg"
          })
        ], 2),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("a", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedLang), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (lang, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["dropdown-item d-flex cursor-pointer lang-item", { 'active-lang': _ctx.selectedLang == lang }]),
                      onClick: ($event: any) => (_ctx.changeLanguage(lang)),
                      key: index
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.i18n.t('lang.' + lang + '.symbole')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('lang.' + lang + '.title')), 1)
                    ], 10, _hoisted_8))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.user?.firstName || '') + " " + _toDisplayString(_ctx.user?.lastName || ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.user?.email || ''), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_18, [
                  (_ctx.hasAdminRole())
                    ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: { name: 'clubs', params: { userUUID: _ctx.userUUID } },
                          class: "bg-none text-body py-1 d-block w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "shop",
                              size: "lg",
                              class: "me-2 icon-md"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.admin_space')), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    class: "dropdown-item cursor-pointer border-bottom",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchClub()))
                  }, [
                    _createElementVNode("a", _hoisted_20, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "repeat",
                        size: "lg",
                        class: "me-2 icon-md"
                      }),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.switch_club')), 1)
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_22, [
                    _createVNode(_component_router_link, {
                      to: { name: 'profile', params: { userUUID: _ctx.userUUID } },
                      class: "bg-none text-body py-1 d-block w-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "user-tie",
                          size: "lg",
                          class: "me-2 icon-md"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.profile')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: { name: 'support', params: { userUUID: _ctx.userUUID } },
                      class: "bg-none text-body py-1 d-block w-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "headset",
                          size: "lg",
                          class: "me-2 icon-md"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.support')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", {
                    class: "dropdown-item cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("a", _hoisted_24, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "sign-out-alt",
                        size: "lg",
                        class: "me-2 icon-md"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.logout')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}